module.exports = __webpack_public_path__ + "img/e_pic_register3.1766306608134.png";